module.exports = __webpack_public_path__ + "static/media/global-shoppng-31.c9e7fb89.png";